define(['exports', 'react', '../../i18n', '../../assets/correct.svg', '../../assets/wrong.svg', './ReportSectionsWrapperInfo'], function (exports, _react, _i18n, _correct, _wrong, _ReportSectionsWrapperInfo) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _i18n2 = _interopRequireDefault(_i18n);

	var _correct2 = _interopRequireDefault(_correct);

	var _wrong2 = _interopRequireDefault(_wrong);

	var _ReportSectionsWrapperInfo2 = _interopRequireDefault(_ReportSectionsWrapperInfo);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	var _get = function get(object, property, receiver) {
		if (object === null) object = Function.prototype;
		var desc = Object.getOwnPropertyDescriptor(object, property);

		if (desc === undefined) {
			var parent = Object.getPrototypeOf(object);

			if (parent === null) {
				return undefined;
			} else {
				return get(parent, property, receiver);
			}
		} else if ("value" in desc) {
			return desc.value;
		} else {
			var getter = desc.get;

			if (getter === undefined) {
				return undefined;
			}

			return getter.call(receiver);
		}
	};

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var MCQSecProblemAnalysis = function (_ReportSectionsWrappe) {
		_inherits(MCQSecProblemAnalysis, _ReportSectionsWrappe);

		function MCQSecProblemAnalysis(props) {
			_classCallCheck(this, MCQSecProblemAnalysis);

			return _possibleConstructorReturn(this, (MCQSecProblemAnalysis.__proto__ || Object.getPrototypeOf(MCQSecProblemAnalysis)).call(this, props));
		}

		_createClass(MCQSecProblemAnalysis, [{
			key: 'renderCorrectnessDetail',
			value: function renderCorrectnessDetail() {
				var hasAnsweredCorrect = this.props.problemAnalysis.hasAnsweredCorrect;

				return _react2.default.createElement(
					'div',
					{ className: 'col-6 px4 py2 border rounded-left' },
					_react2.default.createElement(
						'div',
						{ className: 'field-name-primary' },
						_i18n2.default.t('dk-ui-lib.reports.correctness')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mt2' },
						hasAnsweredCorrect ? _react2.default.createElement(_correct2.default, { className: 'svg-icon svg-2x' }) : _react2.default.createElement(_wrong2.default, { className: 'svg-icon svg-2x' })
					)
				);
			}
		}, {
			key: 'renderSpeedDetails',
			value: function renderSpeedDetails() {
				var _props$problemAnalysi = this.props.problemAnalysis,
				    speed = _props$problemAnalysi.speed,
				    recommendedSpeed = _props$problemAnalysi.recommendedSpeed;


				return _react2.default.createElement(
					'div',
					{ className: 'col-6 px4 py2 border-top border-bottom border-right rounded-right' },
					_react2.default.createElement(
						'div',
						{ className: 'mb2 field-name-primary' },
						_i18n2.default.t('dk-ui-lib.reports.speed')
					),
					speed && recommendedSpeed && _get(MCQSecProblemAnalysis.prototype.__proto__ || Object.getPrototypeOf(MCQSecProblemAnalysis.prototype), 'renderSpeedDetail', this).call(this, speed, recommendedSpeed),
					!(speed && recommendedSpeed) && 'N/A'
				);
			}
		}, {
			key: 'renderAnalysis',
			value: function renderAnalysis() {
				return _react2.default.createElement(
					'div',
					{ className: 'clearfix flex mt2' },
					this.renderCorrectnessDetail(),
					this.renderSpeedDetails()
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    _props$problemAnalysi2 = _props.problemAnalysis,
				    name = _props$problemAnalysi2.name,
				    description = _props$problemAnalysi2.description,
				    concepts = _props$problemAnalysi2.concepts,
				    id = _props$problemAnalysi2.id,
				    index = _props.index;

				return _react2.default.createElement(
					'div',
					null,
					_get(MCQSecProblemAnalysis.prototype.__proto__ || Object.getPrototypeOf(MCQSecProblemAnalysis.prototype), 'renderProblemName', this).call(this, name ? name : 'Quiz ' + (index + 1), _i18n2.default.t('dk-ui-lib.reports.problem_info'), concepts, id),
					this.renderAnalysis()
				);
			}
		}]);

		return MCQSecProblemAnalysis;
	}(_ReportSectionsWrapperInfo2.default);

	exports.default = MCQSecProblemAnalysis;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/MCQSecProblemAnalysis.js
// module id = 1199
// module chunks = 0